import HttpRequest from 'core/http/singleton/auth';

export const confirmTokenSignUp = async (token: any): Promise<any> => {
  const res = await HttpRequest.post<any>(`api/owner/confirm-token?token=${token}`);
  return res.data;
};
